<template />

<script>
export default {
    name: 'Commission'
};
</script>

<style scoped></style>
